
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13291',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13291",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.850",
  "client-types": "static-1.501",
  "data-fetching-client": "static-1.9988",
  "foundations-components": "static-1.8537",
  "foundations-components-legacy": "static-1.1562",
  "foundations-theming": "static-1.4811",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.89",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8368",
  "hub-http-shared-msw-handlers": "static-1.10669",
  "hubspot-dlb": "static-2.1905",
  "hubspot-url-utils": "static-1.4366",
  "HubStyleTokens": "static-2.11826",
  "I18n": "static-7.1678",
  "jasmine-runner": "static-1.6785",
  "marketplace-discovery-studio-lib": "static-1.685",
  "marketplace-storefront-base": "static-1.13354",
  "quartz": "static-1.7499",
  "react-dlb": "static-1.89",
  "react-rhumb": "static-1.17057",
  "reactive-variable-buffer-atom": "static-1.3189",
  "reporting-testing-lib": "static-1.10837",
  "reselect": "static-3.12",
  "settings-ui-lib": "static-1.12859",
  "SharedI18nStrings": "static-1.183",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7667",
  "ui-addon-i18n": "static-1.11481",
  "ui-addon-react-router-dom": "static-1.9867",
  "unified-auth": "static-1.971",
  "unified-auth-core-lib": "static-1.1253",
  "usage-tracker": "static-1.7648",
  "usage-tracker-core": "static-1.7498",
  "customer-data-property-utils": "static-1.8433",
  "hub-http": "static-1.6547",
  "integrations-lib": "static-1.17112",
  "marketplace-ui-common": "static-1.20791",
  "marketplace-ui-install": "static-1.777",
  "property-management-iframe": "static-1.14189",
  "quartz-config": "static-1.1277",
  "quartz-core": "static-1.6718",
  "quartz-routing": "static-1.929",
  "quick-fetch": "static-1.4150",
  "react": "static-7.196",
  "rpc-client-utils": "static-1.5000",
  "ts-schema": "static-1.4316",
  "ui-universal-auth": "static-1.9457",
  "UIComponents": "static-3.8772",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.87",
  "metrics-js": "static-1.9963",
  "react-redux": "static-7.79",
  "redux": "static-4.80",
  "styled-components": "static-2.99",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3776",
  "quartz-webpack": "static-1.3723",
  "bend-plugin-quartz-routing": "static-1.577",
  "ai-components-ui-library": "static-1.9780",
  "codemirror": "static-5.102",
  "foundations-assets": "static-1.5221",
  "pulse": "static-1.964",
  "react-codemirror": "static-1.10978",
  "ui-extensions-preview-lib": "static-1.662",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4806",
  "floating-ui": "static-1.63",
  "foundations-theming-specialty": "static-1.2527",
  "framer-motion": "static-1.79",
  "hs-story-utils": "static-1.9760",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.77",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5578",
  "react-virtualized": "static-2.107",
  "StyleGuideUI": "static-3.506",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2728",
  "ui-fonts": "static-1.1088",
  "ui-images": "static-2.1260",
  "bend-plugin-foundations-theming": "static-1.3294",
  "foundations-theming-base": "static-1.3796",
  "stylex": "static-1.41",
  "HeadJS": "static-2.802",
  "hs-test-utils-bend-plugin": "static-1.3479",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4647",
  "ui-addon-video-player": "static-1.9037",
  "ai-rendering-library": "static-1.11151",
  "chirp-fetch": "static-1.2231",
  "connections-embed-lib": "static-1.1556",
  "copilot-toolkit": "static-1.11896",
  "feedback-loader": "static-1.29851",
  "laboratory-lib": "static-3.7488",
  "marketplace-embed": "static-1.22970",
  "marketplace-ui-details": "static-1.10686",
  "marketplace-ui-reviews": "static-1.20746",
  "marketplace-ui-tracking": "static-1.14961",
  "sanitize-text": "static-1.8492",
  "usage-tracker-multi": "static-1.6062",
  "usage-tracker-session-replay": "static-1.5334",
  "wootric-nps": "static-1.7223",
  "quartz-head": "static-1.1164",
  "web-vitals": "static-1.15",
  "apollo-link-hub-http": "static-2.4992",
  "immer": "static-1.101",
  "immerable": "static-1.4481",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2713",
  "reporting-data": "static-1.68904",
  "cssUtils": "static-1.957",
  "flux-actions": "static-1.372",
  "react-colorpicker": "static-2.10548",
  "react-dnd-compat": "static-1.4951",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10705",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7638",
  "icons": "static-2.692",
  "marketplace-ui-apps-core": "static-1.19323",
  "storybook-react": "static-1.40",
  "trellis-story-utils": "static-1.4842",
  "foundations-components-test-utils": "static-1.6020",
  "quartz-i18n": "static-1.1174",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.520",
  "ads-unified-auth-lib": "static-1.1493",
  "custom-vendor-connection-lib": "static-1.21",
  "google-sheets-integration-lib": "static-1.1085",
  "microsoft-drive-auth-lib": "static-1.201",
  "surveymonkey-integration-lib": "static-1.539",
  "slack-ui-library": "static-1.10734",
  "fsm": "static-1.4087",
  "customer-data-objects": "static-1.8032",
  "property-translator": "static-1.5729",
  "hs-locale-management": "static-1.317",
  "frontend-preferences-client": "static-1.8253",
  "hs-promise-utils": "static-1.5925",
  "hubspot-apollo-client": "static-1.5212",
  "integrations-error-boundary-lib": "static-1.14527",
  "integrations-tracking-lib": "static-1.5943",
  "native-integrations-shared-strings": "static-1.8112",
  "sanitize": "static-1.4807",
  "superstore": "static-1.5094",
  "ui-shepherd-react": "static-3.10604",
  "ai-settings-ui-library": "static-1.8384",
  "hub-http-janus": "static-1.886",
  "hubspotter-http": "static-1.4886",
  "immutable-less": "static-1.4986",
  "marketplace-ui-client-types": "static-1.18198",
  "nav-meta": "static-1.30525",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18422",
  "ui-product-approvals-common": "static-1.1149",
  "ai-studio-lib": "static-1.12485",
  "hubspot-prosemirror": "static-1.19035",
  "integrations-reconnect-lib": "static-1.529",
  "ui-addon-iframeable": "static-1.9411",
  "ui-addon-integrations-directory-panel": "static-2.8361",
  "ui-product-approvals": "static-1.29254",
  "ui-tool-access": "static-1.10490",
  "inbound-db-properties-service-client": "static-1.4070",
  "property-management-common": "static-1.6477",
  "opentelemetry-fe-types": "static-1.111",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.582",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.486",
  "quartz-auth": "static-1.1174",
  "quartz-test": "static-1.1174",
  "quartz-tracking": "static-1.878",
  "trellis-components": "static-1.2747",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.410",
  "HubStyle": "static-2.12133",
  "bender-build-tools": "static-1.3452",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23179",
  "ContentUtils": "static-1.69184",
  "customer-data-objects-ui-components": "static-1.13366",
  "sassPrefix": "static-1.224",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.467",
  "batch-promise": "static-1.1880",
  "event-emitter": "static-1.1290",
  "fast-json-patch": "static-1.70",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5781",
  "magpie-types": "static-1.5241",
  "stylex-utils": "static-1.146",
  "trellis-theming": "static-1.1308",
  "avatar-components": "static-1.2817",
  "breeze-engine-core": "static-1.1096",
  "breeze-onboarding-components": "static-1.790",
  "customer-data-filters-ui": "static-1.41007",
  "customer-data-reference-ui-components": "static-1.13514",
  "embedded-academy-lib": "static-1.15605",
  "ExportDialog": "static-6.10713",
  "global-styles-ai-lib": "static-1.197",
  "highlight.js": "static-1.86",
  "marketplace-embed-ba": "static-1.673",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42119",
  "reporting-snowflake": "static-1.57521",
  "reporting-ui-components": "static-2.66174",
  "reporting-visualizations": "static-1.60979",
  "trial-components-library": "static-1.14156",
  "ui-addon-teams": "static-1.21944",
  "upgrade-components-lib": "static-1.557",
  "navigation-components": "static-1.18888",
  "breeze-engine-lib": "static-1.1818",
  "simple-logging-lib": "static-1.3386",
  "fail-safe": "static-1.289",
  "app-governance-lib": "static-1.2442",
  "developer-experience-shared-components": "static-1.10873",
  "purchase-motions-components": "static-1.6406",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10354",
  "usage-tracker-anonymous": "static-1.6065",
  "usage-tracker-public": "static-1.7459",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.4037",
  "reference-resolvers": "static-1.8516",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4252",
  "hubspot-apollo-cache": "static-1.671",
  "universal-page-editor-lib": "static-1.3343",
  "final-form": "static-1.78",
  "redux-toolkit": "static-1.78",
  "simple-data-table": "static-1.3569",
  "merchandise-lib": "static-1.279",
  "ui-addon-draggable": "static-3.5091",
  "content-assistance-lib": "static-1.8239",
  "content-media-capture": "static-1.5504",
  "customer-data-ui-utilities": "static-1.10166",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24572",
  "growth-payments-core": "static-1.26243",
  "knowledge-content-types": "static-1.8680",
  "PatternValidationJS": "static-1.3227",
  "payment-link-components": "static-1.24210",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20347",
  "ui-addon-emoji-picker": "static-1.10219",
  "ui-business-units-lib": "static-1.9425",
  "video-components-external": "static-1.12198",
  "video-data-lib": "static-1.35856",
  "navigation-messaging": "static-1.8215",
  "collaboration-sidebar": "static-1.58781",
  "crm-component-utils": "static-1.39898",
  "crm-properties-common-lib": "static-1.6225",
  "customer-data-properties": "static-1.52676",
  "external-options-client-types": "static-1.4363",
  "framework-data-schema-resolvers": "static-1.7228",
  "property-value-citations": "static-1.3290",
  "reference-resolvers-lite": "static-1.8439",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.39",
  "hubspotter-http-shared-msw-handlers": "static-1.10667",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "cms-field-types": "static-1.5147",
  "content-icons-ui": "static-1.2398",
  "atom": "static-1.5417",
  "idb-keyval": "static-1.51",
  "reactive-lib": "static-1.1054",
  "breeze-artifacts-sdk": "static-1.442",
  "getting-started-shared-tasks": "static-1.19302",
  "onboarding-journeys-lib": "static-1.995",
  "onboarding-scopes": "static-1.6788",
  "conversations-skeleton-state": "static-1.7582",
  "crm-message-bus": "static-1.43825",
  "customer-data-filters-ui-msw-helpers": "static-1.23442",
  "events-data-lib": "static-1.583",
  "FormUrlGenerator": "static-2.5061",
  "framework-builder-read-service-client": "static-1.4244",
  "hs-resources": "static-1.527",
  "multi-account-reference-resolvers": "static-1.1342",
  "onboarding-tours": "static-1.17169",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14519",
  "academy-common-lib": "static-1.15065",
  "dashboard-lib": "static-1.82930",
  "hubspot-prosemirror-plugins": "static-1.19027",
  "share-with-third-party-component-lib": "static-1.9043",
  "ui-asset-management-lib": "static-1.11433",
  "user-context": "static-1.5456",
  "reporting-plugins": "static-1.10794",
  "reporting-reports": "static-1.68581",
  "hubs-service-types": "static-1.1595",
  "purchase-motions-api": "static-1.6409",
  "salesImages": "static-1.595",
  "signup-constants": "static-1.19679",
  "nest": "static-1.572",
  "breeze-engine-chat-components": "static-1.796",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.240",
  "framework-listing-lib": "static-2.29556",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31499",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4568",
  "signup-ui-url-generator": "static-2.8395",
  "onboarding-tours-client": "static-1.5384",
  "one-click-checkout": "static-1.470",
  "platform-infra-nav-components": "static-1.7916",
  "subscription-experience-data-types": "static-1.15270",
  "crm-record-cards-service-types": "static-1.3796",
  "location-customization-utils-lib": "static-1.10157",
  "redux-thunk": "static-2.80",
  "react-flip-move": "static-1.78",
  "ui-coaching-tips": "static-1.29363",
  "content-media-composition-data-lib": "static-1.13308",
  "fix-webm-duration": "static-1.30",
  "notification-sounds": "static-1.4760",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.793",
  "ui-addon-opt": "static-4.8701",
  "commerce-tours-lib": "static-1.6663",
  "growth-onboarding-reliability": "static-1.5415",
  "sales-checkout-service-client": "static-1.3863",
  "data-token-picker": "static-1.16927",
  "FileManagerLib": "static-1.40212",
  "content-media-compositions": "static-2.17315",
  "media-bridge-lib": "static-1.19445",
  "chatspot-widget-iframe": "static-1.23170",
  "collaboration-sidebar-common": "static-1.3578",
  "marketing-platform-lib": "static-1.7208",
  "card-properties-lib": "static-1.45069",
  "commerce-subscription-lib": "static-1.37842",
  "crm-actions": "static-1.6683",
  "crm-cards-sdk": "static-1.44656",
  "customer-data-properties-shared-msw-handlers": "static-1.9996",
  "customer-data-tracking": "static-1.7217",
  "calling-global-api": "static-1.65710",
  "calling-internal-common": "static-1.31657",
  "calling-lifecycle-internal": "static-1.67092",
  "calling-lifecycle-messages": "static-1.59386",
  "commerce-products-lib": "static-1.10600",
  "conditional-properties-service-client": "static-1.4039",
  "crm-index-visualization-core": "static-1.4582",
  "crm-links": "static-1.6658",
  "crm-pipelines-api-client-types": "static-1.4370",
  "formula-editor": "static-1.14810",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4451",
  "meetings-icalendar-utils-lib": "static-1.970",
  "multi-currency-client-types": "static-1.3930",
  "object-builder-ui-client": "static-1.49746",
  "pipeline-validation-client-types": "static-1.4205",
  "smart-data-capture-core": "static-1.189",
  "smart-property-lib": "static-1.8358",
  "tiered-pricing": "static-1.2005",
  "topics-actions-lib": "static-1.503",
  "ui-addon-form-validation": "static-1.11319",
  "zustand": "static-1.85",
  "fdsr-migration-layer": "static-1.347",
  "framework-data-schema-quick-fetch": "static-1.7133",
  "restore-request-side-panel-lib": "static-1.1733",
  "growth-data-modal": "static-1.5934",
  "growth-onboarding-confetti": "static-1.3400",
  "growth-onboarding-next-action-utils": "static-1.2744",
  "onboarding-tours-utils": "static-1.1236",
  "ui-shepherd-tracker": "static-1.7985",
  "academy-service-client": "static-1.4027",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40071",
  "SafeStorage": "static-1.4741",
  "video-embed": "static-1.36690",
  "redux-actions": "static-3.70",
  "EmailSignatureEditor": "static-1.25048",
  "viral-links-lib": "static-1.7411",
  "nested-table": "static-1.570",
  "timezone-utils": "static-2.5578",
  "getting-started-shared-tasks-store": "static-1.18420",
  "campaign-roi-lib": "static-1.10364",
  "campaigns-utils-lib": "static-1.3557",
  "ui-addon-calendars": "static-2.5676",
  "customer-data-views-management": "static-1.26080",
  "framework-data-table": "static-2.12603",
  "nudge-client-utils": "static-1.3188",
  "nudge-custom-ui-functions": "static-1.1535",
  "switchboard-lib": "static-1.555",
  "access-check-ui-lib": "static-1.1643",
  "app-users-service-client": "static-1.5955",
  "app-users-service-types": "static-1.5363",
  "mini-checkout-client": "static-1.27565",
  "onboarding-utils": "static-1.5706",
  "permissions-shared-i18n-strings-fe": "static-1.2123",
  "ui-coaching-tips-shared-config": "static-1.29348",
  "checkout-sdk": "static-3.24408",
  "payment-method-components": "static-1.7182",
  "touchless-buying-components": "static-1.6276",
  "upgrade-catalog-service-types": "static-1.3796",
  "edison-service-client-types": "static-1.729",
  "growth-onboarding-feedback-components": "static-1.6920",
  "audio-components": "static-1.6386",
  "FileManagerImages": "static-1.37723",
  "video-components": "static-1.14200",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92901",
  "customer-data-sidebar": "static-2.46788",
  "enrichment-lib": "static-1.508",
  "ui-addon-draggable-compat": "static-2.4598",
  "universal-record-utils-lib": "static-1.2049",
  "commerce-billing-lib": "static-1.20259",
  "commerce-shared-components-lib": "static-1.19291",
  "commerce-tools-ui-lib": "static-1.11098",
  "crm-fe-perf": "static-1.23233",
  "calling-error-reporting": "static-1.31664",
  "shared-worker-versioning": "static-1.11376",
  "calling-usage-tracker": "static-1.6871",
  "voice-sms-access-library": "static-1.2123",
  "commerce-permissions": "static-1.1112",
  "products-iframe-lib": "static-1.8639",
  "products-ui-components-shared-msw-handlers": "static-1.11051",
  "crm-index-associations-lib": "static-1.6779",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10752",
  "sales-views-client-types": "static-1.4591",
  "bark-lib": "static-1.16849",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.691",
  "policy-lib": "static-1.7139",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10815",
  "onboarding-data-sync-lib": "static-1.2557",
  "growth-onboarding-next-action-components": "static-1.2772",
  "user-context-client": "static-1.4843",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4865",
  "outpost": "static-1.4488",
  "draft-convert": "static-2.80",
  "draft-extend": "static-3.83",
  "draft-js": "static-5.85",
  "draft-plugins": "static-2.22198",
  "sales-email-signature-service-client": "static-1.4182",
  "ts-utils-lib": "static-1.483",
  "copilot-messaging": "static-1.2146",
  "crm-export-dialog": "static-1.6618",
  "crm-index-ui-shimmer": "static-1.2724",
  "crm-view-components": "static-1.1244",
  "react-beautiful-dnd": "static-1.70",
  "customer-data-associations": "static-1.7665",
  "tasks-actions-lib": "static-1.190",
  "nudge-custom-function-registry": "static-1.2945",
  "nudge-renderer-utils": "static-1.3264",
  "whisper-core-api": "static-1.7383",
  "InboxConnectUtils": "static-4.15610",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46900",
  "hub-http-rxjs": "static-1.853",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4327",
  "company-details-components": "static-1.6542",
  "react-performance-metrics-lib": "static-1.888",
  "pricing-pages-ui-components": "static-1.15951",
  "quote-checkout-service-types": "static-1.3788",
  "social-insights-client-types": "static-1.22706",
  "crm_universal": "static-1.22533",
  "customer-data-email": "static-1.18561",
  "card-payment-highlight-lib": "static-1.38048",
  "commerce-contract-lib": "static-1.13420",
  "invoices-highlight-card-lib": "static-1.55826",
  "orders-highlight-card-lib": "static-1.22246",
  "products-highlight-card-lib": "static-1.18883",
  "quotes-highlight-card-lib": "static-1.72850",
  "crm-source-interpretation-lib": "static-1.5666",
  "data-agent-utils": "static-1.570",
  "crm-object-search-query-utilities": "static-1.10241",
  "utility-belt": "static-1.2868",
  "payments-enrollment-embed-lib": "static-1.23897",
  "stripe-embedded-components": "static-1.8035",
  "customer-data-rte": "static-1.33694",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6322",
  "payments-post-enroll-local-storage-lib": "static-1.5439",
  "qrcode-generator": "static-1.76",
  "quotes-client-types": "static-1.38940",
  "calling-orchestration-schema": "static-1.36900",
  "react-reducer-toolkit": "static-1.16418",
  "meetings-connect-utils-lib": "static-1.7946",
  "hub-http-contrib": "static-1.3375",
  "ui-addon-sales-email": "static-1.5549",
  "access-control-lib": "static-1.10772",
  "EmailComponents": "static-1.55604",
  "EmailData": "static-1.54282",
  "redux-less": "static-2.9810",
  "company-details-service-types": "static-1.4278",
  "segments-query-core": "static-1.1759",
  "pricing-pages-api": "static-1.15816",
  "sequences-lib": "static-1.8571",
  "ui-gdpr-components": "static-1.10631",
  "products-ui-components": "static-1.41118",
  "accounting-integrations-ui-components": "static-1.7577",
  "invoices-ui-lib": "static-1.55842",
  "commerce-products-api": "static-1.2725",
  "invoices-iframe-lib": "static-1.57900",
  "quotes-modal-lib": "static-1.103528",
  "quotes-ui-lib": "static-1.81571",
  "stripe-connect-js": "static-1.78",
  "draft-content-plugins": "static-1.28952",
  "ContentComponents": "static-2.72140",
  "ContentData": "static-1.69259",
  "marketing-email-service-types": "static-1.2114",
  "messaging-editing-lib": "static-1.47204",
  "messaging-usage-based-billing-components-lib": "static-1.2066",
  "automation-ui-source-apps": "static-1.19739",
  "automation-ui-types": "static-1.20657",
  "messaging-types-lib": "static-1.46941",
  "onboarding-settings-client": "static-1.4844",
  "sequences-client-types-lib": "static-1.8428",
  "commerce-tax-lib": "static-1.875",
  "price-books-api": "static-1.1783",
  "price-books-components": "static-1.1841",
  "property-description-translator": "static-1.4172",
  "ramp-editor": "static-1.939",
  "commerce-analytics-service-client": "static-1.3851",
  "totals-ui-components": "static-1.24342",
  "SalesContentIndexUI": "static-3.9658",
  "advanced-menus-core": "static-1.15618",
  "advanced-menus-lib": "static-1.12490",
  "automation-ui-ubb": "static-1.6573",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7672",
  "data-token-views": "static-1.16908",
  "forms-utils-lib": "static-1.13132",
  "payments-embed-points-lib": "static-1.13635",
  "react-tinymce": "static-1.56033",
  "simple-menus-core": "static-1.15617",
  "simple-menus-lib": "static-1.17134",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55159",
  "tinymce-data": "static-1.41244",
  "tinymce-plugins": "static-1.58273",
  "tinymce-themes": "static-1.57129",
  "ui-brand-identity-lib": "static-1.16599",
  "ui-memberships-settings-lib": "static-1.34896",
  "videoconference-integration-components": "static-1.7325",
  "automation-applications-service-types": "static-1.3657",
  "automation-platform-service-types": "static-1.2668",
  "ContentEditorUI": "static-2.77971",
  "content-whatsapp-service-types": "static-1.578",
  "short-messages-app-service-client": "static-1.4253",
  "web-interactives-components": "static-1.14288",
  "web-interactives-data": "static-1.14289",
  "messaging-shared-utils-lib": "static-1.1515",
  "messaging-user-info-utils-lib": "static-1.1685",
  "email-portal-health-service-types": "static-1.1317",
  "line-items-api": "static-1.1133",
  "commerce-totals-service-types": "static-1.4055",
  "FireAlarmUi": "static-1.4747",
  "sales-templates-service-types-lib": "static-1.4407",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22593",
  "automation-ui-usage-tracking": "static-1.22056",
  "data-studio-ubb": "static-1.3563",
  "interframe": "static-3.5090",
  "layout-dnd-components": "static-1.13013",
  "layout-dnd-utils": "static-1.11988",
  "NamespacedHubStyle": "static-2.9288",
  "campaigns-lib": "static-1.27708",
  "content-management-data-lib": "static-1.6005",
  "copilot-plugins": "static-1.11868",
  "cta-picker": "static-1.37132",
  "customer-agent-discovery-components-lib": "static-1.4011",
  "editor-components": "static-1.13690",
  "editor-iframe-lib": "static-1.8837",
  "error-messaging-js": "static-1.5534",
  "FormsCommonComponents": "static-1.86634",
  "layout-data-lib": "static-1.10313",
  "pictos": "static-7.191",
  "react-transition-group": "static-2.73",
  "redux-request-state": "static-1.10982",
  "SharedLegalStrings": "static-1.2077",
  "smart-content-core": "static-1.43226",
  "smart-content-lib": "static-1.43879",
  "social-composer-lib": "static-1.60336",
  "structured-content-lib": "static-1.25970",
  "theme-previewer-lib": "static-1.53958",
  "tinymce-copilot": "static-1.17227",
  "xray-recommendation-lib": "static-1.8298",
  "automation-ui-routing": "static-1.22014",
  "sql-reporting-client-types": "static-1.5918",
  "attribution-lib": "static-1.42839",
  "reporting-enablement": "static-1.23880",
  "forms-ai-lib": "static-1.4802",
  "codemirror-dlb": "static-1.59530",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6777",
  "report-customization-components": "static-1.13961",
  "data-quality-ui-library": "static-1.13895",
  "reporting-filters": "static-1.1048",
  "reporting-insights-lib": "static-1.2635",
  "merge-modal-lib": "static-1.12651",
  "segments-client-types": "static-1.11657"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13291",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.850",
  "client-types": "/client-types/static-1.501",
  "data-fetching-client": "/data-fetching-client/static-1.9988",
  "foundations-components": "/foundations-components/static-1.8537",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1562",
  "foundations-theming": "/foundations-theming/static-1.4811",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.89",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8368",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10669",
  "hubspot-dlb": "/hubspot-dlb/static-2.1905",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
  "HubStyleTokens": "/HubStyleTokens/static-2.11826",
  "I18n": "/I18n/static-7.1678",
  "jasmine-runner": "/jasmine-runner/static-1.6785",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.685",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13354",
  "quartz": "/quartz/static-1.7499",
  "react-dlb": "/react-dlb/static-1.89",
  "react-rhumb": "/react-rhumb/static-1.17057",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3189",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10837",
  "reselect": "/reselect/static-3.12",
  "settings-ui-lib": "/settings-ui-lib/static-1.12859",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7667",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11481",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9867",
  "unified-auth": "/unified-auth/static-1.971",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1253",
  "usage-tracker": "/usage-tracker/static-1.7648",
  "usage-tracker-core": "/usage-tracker-core/static-1.7498",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8433",
  "hub-http": "/hub-http/static-1.6547",
  "integrations-lib": "/integrations-lib/static-1.17112",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20791",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.777",
  "property-management-iframe": "/property-management-iframe/static-1.14189",
  "quartz-config": "/quartz-config/static-1.1277",
  "quartz-core": "/quartz-core/static-1.6718",
  "quartz-routing": "/quartz-routing/static-1.929",
  "quick-fetch": "/quick-fetch/static-1.4150",
  "react": "/react/static-7.196",
  "rpc-client-utils": "/rpc-client-utils/static-1.5000",
  "ts-schema": "/ts-schema/static-1.4316",
  "ui-universal-auth": "/ui-universal-auth/static-1.9457",
  "UIComponents": "/UIComponents/static-3.8772",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.87",
  "metrics-js": "/metrics-js/static-1.9963",
  "react-redux": "/react-redux/static-7.79",
  "redux": "/redux/static-4.80",
  "styled-components": "/styled-components/static-2.99",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3776",
  "quartz-webpack": "/quartz-webpack/static-1.3723",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.577",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9780",
  "codemirror": "/codemirror/static-5.102",
  "foundations-assets": "/foundations-assets/static-1.5221",
  "pulse": "/pulse/static-1.964",
  "react-codemirror": "/react-codemirror/static-1.10978",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.662",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4806",
  "floating-ui": "/floating-ui/static-1.63",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2527",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-story-utils": "/hs-story-utils/static-1.9760",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.77",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5578",
  "react-virtualized": "/react-virtualized/static-2.107",
  "StyleGuideUI": "/StyleGuideUI/static-3.506",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2728",
  "ui-fonts": "/ui-fonts/static-1.1088",
  "ui-images": "/ui-images/static-2.1260",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3294",
  "foundations-theming-base": "/foundations-theming-base/static-1.3796",
  "stylex": "/stylex/static-1.41",
  "HeadJS": "/HeadJS/static-2.802",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3479",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4647",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9037",
  "ai-rendering-library": "/ai-rendering-library/static-1.11151",
  "chirp-fetch": "/chirp-fetch/static-1.2231",
  "connections-embed-lib": "/connections-embed-lib/static-1.1556",
  "copilot-toolkit": "/copilot-toolkit/static-1.11896",
  "feedback-loader": "/feedback-loader/static-1.29851",
  "laboratory-lib": "/laboratory-lib/static-3.7488",
  "marketplace-embed": "/marketplace-embed/static-1.22970",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10686",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20746",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14961",
  "sanitize-text": "/sanitize-text/static-1.8492",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6062",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5334",
  "wootric-nps": "/wootric-nps/static-1.7223",
  "quartz-head": "/quartz-head/static-1.1164",
  "web-vitals": "/web-vitals/static-1.15",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4992",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4481",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2713",
  "reporting-data": "/reporting-data/static-1.68904",
  "cssUtils": "/cssUtils/static-1.957",
  "flux-actions": "/flux-actions/static-1.372",
  "react-colorpicker": "/react-colorpicker/static-2.10548",
  "react-dnd-compat": "/react-dnd-compat/static-1.4951",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10705",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7638",
  "icons": "/icons/static-2.692",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19323",
  "storybook-react": "/storybook-react/static-1.40",
  "trellis-story-utils": "/trellis-story-utils/static-1.4842",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6020",
  "quartz-i18n": "/quartz-i18n/static-1.1174",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.520",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1493",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.21",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1085",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.201",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.539",
  "slack-ui-library": "/slack-ui-library/static-1.10734",
  "fsm": "/fsm/static-1.4087",
  "customer-data-objects": "/customer-data-objects/static-1.8032",
  "property-translator": "/property-translator/static-1.5729",
  "hs-locale-management": "/hs-locale-management/static-1.317",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8253",
  "hs-promise-utils": "/hs-promise-utils/static-1.5925",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5212",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14527",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5943",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8112",
  "sanitize": "/sanitize/static-1.4807",
  "superstore": "/superstore/static-1.5094",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10604",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8384",
  "hub-http-janus": "/hub-http-janus/static-1.886",
  "hubspotter-http": "/hubspotter-http/static-1.4886",
  "immutable-less": "/immutable-less/static-1.4986",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18198",
  "nav-meta": "/nav-meta/static-1.30525",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18422",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1149",
  "ai-studio-lib": "/ai-studio-lib/static-1.12485",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19035",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.529",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9411",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8361",
  "ui-product-approvals": "/ui-product-approvals/static-1.29254",
  "ui-tool-access": "/ui-tool-access/static-1.10490",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4070",
  "property-management-common": "/property-management-common/static-1.6477",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.111",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.582",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.486",
  "quartz-auth": "/quartz-auth/static-1.1174",
  "quartz-test": "/quartz-test/static-1.1174",
  "quartz-tracking": "/quartz-tracking/static-1.878",
  "trellis-components": "/trellis-components/static-1.2747",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.410",
  "HubStyle": "/HubStyle/static-2.12133",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23179",
  "ContentUtils": "/ContentUtils/static-1.69184",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13366",
  "sassPrefix": "/sassPrefix/static-1.224",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.467",
  "batch-promise": "/batch-promise/static-1.1880",
  "event-emitter": "/event-emitter/static-1.1290",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5781",
  "magpie-types": "/magpie-types/static-1.5241",
  "stylex-utils": "/stylex-utils/static-1.146",
  "trellis-theming": "/trellis-theming/static-1.1308",
  "avatar-components": "/avatar-components/static-1.2817",
  "breeze-engine-core": "/breeze-engine-core/static-1.1096",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.790",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41007",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13514",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15605",
  "ExportDialog": "/ExportDialog/static-6.10713",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.197",
  "highlight.js": "/highlight.js/static-1.86",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.673",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42119",
  "reporting-snowflake": "/reporting-snowflake/static-1.57521",
  "reporting-ui-components": "/reporting-ui-components/static-2.66174",
  "reporting-visualizations": "/reporting-visualizations/static-1.60979",
  "trial-components-library": "/trial-components-library/static-1.14156",
  "ui-addon-teams": "/ui-addon-teams/static-1.21944",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.557",
  "navigation-components": "/navigation-components/static-1.18888",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1818",
  "simple-logging-lib": "/simple-logging-lib/static-1.3386",
  "fail-safe": "/fail-safe/static-1.289",
  "app-governance-lib": "/app-governance-lib/static-1.2442",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10873",
  "purchase-motions-components": "/purchase-motions-components/static-1.6406",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10354",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6065",
  "usage-tracker-public": "/usage-tracker-public/static-1.7459",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.4037",
  "reference-resolvers": "/reference-resolvers/static-1.8516",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4252",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.671",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3343",
  "final-form": "/final-form/static-1.78",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "simple-data-table": "/simple-data-table/static-1.3569",
  "merchandise-lib": "/merchandise-lib/static-1.279",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5091",
  "content-assistance-lib": "/content-assistance-lib/static-1.8239",
  "content-media-capture": "/content-media-capture/static-1.5504",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10166",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24572",
  "growth-payments-core": "/growth-payments-core/static-1.26243",
  "knowledge-content-types": "/knowledge-content-types/static-1.8680",
  "PatternValidationJS": "/PatternValidationJS/static-1.3227",
  "payment-link-components": "/payment-link-components/static-1.24210",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20347",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10219",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9425",
  "video-components-external": "/video-components-external/static-1.12198",
  "video-data-lib": "/video-data-lib/static-1.35856",
  "navigation-messaging": "/navigation-messaging/static-1.8215",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58781",
  "crm-component-utils": "/crm-component-utils/static-1.39898",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6225",
  "customer-data-properties": "/customer-data-properties/static-1.52676",
  "external-options-client-types": "/external-options-client-types/static-1.4363",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7228",
  "property-value-citations": "/property-value-citations/static-1.3290",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8439",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.39",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10667",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "cms-field-types": "/cms-field-types/static-1.5147",
  "content-icons-ui": "/content-icons-ui/static-1.2398",
  "atom": "/atom/static-1.5417",
  "idb-keyval": "/idb-keyval/static-1.51",
  "reactive-lib": "/reactive-lib/static-1.1054",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.442",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19302",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.995",
  "onboarding-scopes": "/onboarding-scopes/static-1.6788",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7582",
  "crm-message-bus": "/crm-message-bus/static-1.43825",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23442",
  "events-data-lib": "/events-data-lib/static-1.583",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5061",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4244",
  "hs-resources": "/hs-resources/static-1.527",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1342",
  "onboarding-tours": "/onboarding-tours/static-1.17169",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14519",
  "academy-common-lib": "/academy-common-lib/static-1.15065",
  "dashboard-lib": "/dashboard-lib/static-1.82930",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19027",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9043",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11433",
  "user-context": "/user-context/static-1.5456",
  "reporting-plugins": "/reporting-plugins/static-1.10794",
  "reporting-reports": "/reporting-reports/static-1.68581",
  "hubs-service-types": "/hubs-service-types/static-1.1595",
  "purchase-motions-api": "/purchase-motions-api/static-1.6409",
  "salesImages": "/salesImages/static-1.595",
  "signup-constants": "/signup-constants/static-1.19679",
  "nest": "/nest/static-1.572",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.796",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.240",
  "framework-listing-lib": "/framework-listing-lib/static-2.29556",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31499",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4568",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8395",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5384",
  "one-click-checkout": "/one-click-checkout/static-1.470",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7916",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15270",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10157",
  "redux-thunk": "/redux-thunk/static-2.80",
  "react-flip-move": "/react-flip-move/static-1.78",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29363",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13308",
  "fix-webm-duration": "/fix-webm-duration/static-1.30",
  "notification-sounds": "/notification-sounds/static-1.4760",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.793",
  "ui-addon-opt": "/ui-addon-opt/static-4.8701",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6663",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5415",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3863",
  "data-token-picker": "/data-token-picker/static-1.16927",
  "FileManagerLib": "/FileManagerLib/static-1.40212",
  "content-media-compositions": "/content-media-compositions/static-2.17315",
  "media-bridge-lib": "/media-bridge-lib/static-1.19445",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23170",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3578",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7208",
  "card-properties-lib": "/card-properties-lib/static-1.45069",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37842",
  "crm-actions": "/crm-actions/static-1.6683",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44656",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9996",
  "customer-data-tracking": "/customer-data-tracking/static-1.7217",
  "calling-global-api": "/calling-global-api/static-1.65710",
  "calling-internal-common": "/calling-internal-common/static-1.31657",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67092",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59386",
  "commerce-products-lib": "/commerce-products-lib/static-1.10600",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4039",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4582",
  "crm-links": "/crm-links/static-1.6658",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4370",
  "formula-editor": "/formula-editor/static-1.14810",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4451",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.970",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3930",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49746",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4205",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.189",
  "smart-property-lib": "/smart-property-lib/static-1.8358",
  "tiered-pricing": "/tiered-pricing/static-1.2005",
  "topics-actions-lib": "/topics-actions-lib/static-1.503",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11319",
  "zustand": "/zustand/static-1.85",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.347",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7133",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1733",
  "growth-data-modal": "/growth-data-modal/static-1.5934",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3400",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2744",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1236",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7985",
  "academy-service-client": "/academy-service-client/static-1.4027",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40071",
  "SafeStorage": "/SafeStorage/static-1.4741",
  "video-embed": "/video-embed/static-1.36690",
  "redux-actions": "/redux-actions/static-3.70",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25048",
  "viral-links-lib": "/viral-links-lib/static-1.7411",
  "nested-table": "/nested-table/static-1.570",
  "timezone-utils": "/timezone-utils/static-2.5578",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18420",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10364",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3557",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5676",
  "customer-data-views-management": "/customer-data-views-management/static-1.26080",
  "framework-data-table": "/framework-data-table/static-2.12603",
  "nudge-client-utils": "/nudge-client-utils/static-1.3188",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1535",
  "switchboard-lib": "/switchboard-lib/static-1.555",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1643",
  "app-users-service-client": "/app-users-service-client/static-1.5955",
  "app-users-service-types": "/app-users-service-types/static-1.5363",
  "mini-checkout-client": "/mini-checkout-client/static-1.27565",
  "onboarding-utils": "/onboarding-utils/static-1.5706",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2123",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29348",
  "checkout-sdk": "/checkout-sdk/static-3.24408",
  "payment-method-components": "/payment-method-components/static-1.7182",
  "touchless-buying-components": "/touchless-buying-components/static-1.6276",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3796",
  "edison-service-client-types": "/edison-service-client-types/static-1.729",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6920",
  "audio-components": "/audio-components/static-1.6386",
  "FileManagerImages": "/FileManagerImages/static-1.37723",
  "video-components": "/video-components/static-1.14200",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92901",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46788",
  "enrichment-lib": "/enrichment-lib/static-1.508",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4598",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2049",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20259",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19291",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11098",
  "crm-fe-perf": "/crm-fe-perf/static-1.23233",
  "calling-error-reporting": "/calling-error-reporting/static-1.31664",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11376",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6871",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2123",
  "commerce-permissions": "/commerce-permissions/static-1.1112",
  "products-iframe-lib": "/products-iframe-lib/static-1.8639",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11051",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6779",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10752",
  "sales-views-client-types": "/sales-views-client-types/static-1.4591",
  "bark-lib": "/bark-lib/static-1.16849",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.691",
  "policy-lib": "/policy-lib/static-1.7139",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10815",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2557",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2772",
  "user-context-client": "/user-context-client/static-1.4843",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4865",
  "outpost": "/outpost/static-1.4488",
  "draft-convert": "/draft-convert/static-2.80",
  "draft-extend": "/draft-extend/static-3.83",
  "draft-js": "/draft-js/static-5.85",
  "draft-plugins": "/draft-plugins/static-2.22198",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4182",
  "ts-utils-lib": "/ts-utils-lib/static-1.483",
  "copilot-messaging": "/copilot-messaging/static-1.2146",
  "crm-export-dialog": "/crm-export-dialog/static-1.6618",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2724",
  "crm-view-components": "/crm-view-components/static-1.1244",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.70",
  "customer-data-associations": "/customer-data-associations/static-1.7665",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.190",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2945",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3264",
  "whisper-core-api": "/whisper-core-api/static-1.7383",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15610",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46900",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.853",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4327",
  "company-details-components": "/company-details-components/static-1.6542",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.888",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15951",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3788",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "crm_universal": "/crm_universal/static-1.22533",
  "customer-data-email": "/customer-data-email/static-1.18561",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38048",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13420",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55826",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22246",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18883",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72850",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5666",
  "data-agent-utils": "/data-agent-utils/static-1.570",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10241",
  "utility-belt": "/utility-belt/static-1.2868",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23897",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8035",
  "customer-data-rte": "/customer-data-rte/static-1.33694",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6322",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5439",
  "qrcode-generator": "/qrcode-generator/static-1.76",
  "quotes-client-types": "/quotes-client-types/static-1.38940",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36900",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16418",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7946",
  "hub-http-contrib": "/hub-http-contrib/static-1.3375",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5549",
  "access-control-lib": "/access-control-lib/static-1.10772",
  "EmailComponents": "/EmailComponents/static-1.55604",
  "EmailData": "/EmailData/static-1.54282",
  "redux-less": "/redux-less/static-2.9810",
  "company-details-service-types": "/company-details-service-types/static-1.4278",
  "segments-query-core": "/segments-query-core/static-1.1759",
  "pricing-pages-api": "/pricing-pages-api/static-1.15816",
  "sequences-lib": "/sequences-lib/static-1.8571",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10631",
  "products-ui-components": "/products-ui-components/static-1.41118",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7577",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55842",
  "commerce-products-api": "/commerce-products-api/static-1.2725",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57900",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103528",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81571",
  "stripe-connect-js": "/stripe-connect-js/static-1.78",
  "draft-content-plugins": "/draft-content-plugins/static-1.28952",
  "ContentComponents": "/ContentComponents/static-2.72140",
  "ContentData": "/ContentData/static-1.69259",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2114",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47204",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2066",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19739",
  "automation-ui-types": "/automation-ui-types/static-1.20657",
  "messaging-types-lib": "/messaging-types-lib/static-1.46941",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4844",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8428",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.875",
  "price-books-api": "/price-books-api/static-1.1783",
  "price-books-components": "/price-books-components/static-1.1841",
  "property-description-translator": "/property-description-translator/static-1.4172",
  "ramp-editor": "/ramp-editor/static-1.939",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3851",
  "totals-ui-components": "/totals-ui-components/static-1.24342",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9658",
  "advanced-menus-core": "/advanced-menus-core/static-1.15618",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12490",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6573",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7672",
  "data-token-views": "/data-token-views/static-1.16908",
  "forms-utils-lib": "/forms-utils-lib/static-1.13132",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13635",
  "react-tinymce": "/react-tinymce/static-1.56033",
  "simple-menus-core": "/simple-menus-core/static-1.15617",
  "simple-menus-lib": "/simple-menus-lib/static-1.17134",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55159",
  "tinymce-data": "/tinymce-data/static-1.41244",
  "tinymce-plugins": "/tinymce-plugins/static-1.58273",
  "tinymce-themes": "/tinymce-themes/static-1.57129",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16599",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34896",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7325",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3657",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2668",
  "ContentEditorUI": "/ContentEditorUI/static-2.77971",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.578",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4253",
  "web-interactives-components": "/web-interactives-components/static-1.14288",
  "web-interactives-data": "/web-interactives-data/static-1.14289",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1515",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1685",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1317",
  "line-items-api": "/line-items-api/static-1.1133",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4055",
  "FireAlarmUi": "/FireAlarmUi/static-1.4747",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4407",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22593",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22056",
  "data-studio-ubb": "/data-studio-ubb/static-1.3563",
  "interframe": "/interframe/static-3.5090",
  "layout-dnd-components": "/layout-dnd-components/static-1.13013",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11988",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9288",
  "campaigns-lib": "/campaigns-lib/static-1.27708",
  "content-management-data-lib": "/content-management-data-lib/static-1.6005",
  "copilot-plugins": "/copilot-plugins/static-1.11868",
  "cta-picker": "/cta-picker/static-1.37132",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.4011",
  "editor-components": "/editor-components/static-1.13690",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8837",
  "error-messaging-js": "/error-messaging-js/static-1.5534",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86634",
  "layout-data-lib": "/layout-data-lib/static-1.10313",
  "pictos": "/pictos/static-7.191",
  "react-transition-group": "/react-transition-group/static-2.73",
  "redux-request-state": "/redux-request-state/static-1.10982",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2077",
  "smart-content-core": "/smart-content-core/static-1.43226",
  "smart-content-lib": "/smart-content-lib/static-1.43879",
  "social-composer-lib": "/social-composer-lib/static-1.60336",
  "structured-content-lib": "/structured-content-lib/static-1.25970",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53958",
  "tinymce-copilot": "/tinymce-copilot/static-1.17227",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8298",
  "automation-ui-routing": "/automation-ui-routing/static-1.22014",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5918",
  "attribution-lib": "/attribution-lib/static-1.42839",
  "reporting-enablement": "/reporting-enablement/static-1.23880",
  "forms-ai-lib": "/forms-ai-lib/static-1.4802",
  "codemirror-dlb": "/codemirror-dlb/static-1.59530",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6777",
  "report-customization-components": "/report-customization-components/static-1.13961",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13895",
  "reporting-filters": "/reporting-filters/static-1.1048",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2635",
  "merge-modal-lib": "/merge-modal-lib/static-1.12651",
  "segments-client-types": "/segments-client-types/static-1.11657"
}
};
